import type { IconData } from '@stacksjs/iconify-core'

export const emailMailChat: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.1 15.24v1.52h-3.05v1.53H9.91v1.52h4.57v1.52H16v1.53h1.53v1.52h6.09v1.52h1.53v1.53h1.52v1.52h1.52v-6.09h1.53v-1.53h1.52v-6.09h-1.52v-1.53h-1.53v-1.52h-3.04V7.62h-1.53v7.62zm0-9.15h1.52v1.53H22.1Z\"/><path fill=\"currentColor\" d=\"M17.53 10.67h3.04v3.04h-3.04Zm1.52-6.1h3.05v1.52h-3.05Zm-7.62 6.1h3.05v3.04h-3.05Zm-3.05 9.14h1.53v1.52H8.38ZM6.86 3.05h12.19v1.52H6.86Zm0 15.24H5.34v6.09h1.52v-1.52h1.52v-1.53H6.86zm-1.52-7.62h3.04v3.04H5.34Zm-1.53-6.1h3.05v1.52H3.81Zm0 12.19h1.53v1.53H3.81Zm-1.52-1.52h1.52v1.52H2.29Zm0-9.15h1.52v1.53H2.29ZM.76 7.62h1.53v7.62H.76Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default emailMailChat
